import Swiper, { Autoplay, FreeMode, Navigation, Thumbs, Keyboard } from 'swiper'
import { getBreakpointValue } from '../helpers'

const createLightbox = (slides) => {
    const lightboxSourceSlides = Array.from(slides)
    //init html elements
    const modal = document.createElement('div')
    const slidersContainer = document.createElement('div')
    const mainSwiperElement = document.createElement('div')
    const mainSwiperWrapper = document.createElement('div')
    const thumbsSwiperElement = document.createElement('div')
    const thumbsSwiperWrapper = document.createElement('div')
    const nextBtn = document.createElement('div')
    const prevBtn = document.createElement('div')
    const closeBtn = document.createElement('button')

    //layout
    modal.className = 'gallery__lightbox'
    slidersContainer.className = 'gallery__lightbox__column'
    //main swiper
    mainSwiperElement.className = 'swiper gallery__lightbox__main-swiper-el'
    mainSwiperWrapper.className = 'swiper-wrapper gallery__lightbox__swiper-wrapper'
    //thumb swiper
    thumbsSwiperElement.className = 'swiper gallery__lightbox__thumbs-swiper-el'
    thumbsSwiperWrapper.className = 'swiper-wrapper gallery__lightbox__swiper-wrapper'
    //buttons
    nextBtn.classList = 'swiper-button-next gallery__lightbox__next-button'
    prevBtn.classList = 'swiper-button-prev gallery__lightbox__prev-button'
    closeBtn.classList = 'gallery__lightbox__close-button'

    //append main slides
    lightboxSourceSlides.forEach((slide) => {
        const clonedSlide = slide.cloneNode(true)
        clonedSlide.className = 'swiper-slide gallery__lightbox__slide-el'
        mainSwiperWrapper.appendChild(clonedSlide)
    })

    //append thumb slides
    lightboxSourceSlides.forEach((slide) => {
        const clonedSlide = slide.cloneNode(true)
        clonedSlide.className = 'swiper-slide gallery__lightbox__slide-el__thumb'
        thumbsSwiperWrapper.appendChild(clonedSlide)
    })

    // build lightbox's html structure
    mainSwiperElement.appendChild(mainSwiperWrapper)
    mainSwiperElement.appendChild(prevBtn)
    mainSwiperElement.appendChild(nextBtn)

    thumbsSwiperElement.appendChild(thumbsSwiperWrapper)

    slidersContainer.appendChild(mainSwiperElement)
    slidersContainer.appendChild(thumbsSwiperElement)

    modal.appendChild(slidersContainer)
    modal.appendChild(closeBtn)

    const thumbsLightboxSwiper = new Swiper(thumbsSwiperElement, {
        modules: [FreeMode, Thumbs],
        loop: true,
        spaceBetween: 5,
        slidesPerView: 3.3,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            [getBreakpointValue('md')]: {
                slidesPerView: 5.2
            },
            [getBreakpointValue('xxl')]: {
                slidesPerView: 7.2
            }
        }
    })

    const mainLightboxSwiper = new Swiper(mainSwiperElement, {
        modules: [FreeMode, Navigation, Thumbs, Keyboard],
        navigation: true,
        loop: true,
        thumbs: { swiper: thumbsLightboxSwiper },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: false
        }
    })

    const handleOpenLightbox = (targetSlideIndex) => {
        mainLightboxSwiper.slideToLoop(targetSlideIndex)
        document.body.style.overflow = 'hidden'
        document.body.appendChild(modal)
    }

    const handleCloseLightbox = () => {
        document.body.removeChild(modal)
        document.body.style.overflow = 'auto'
    }

    const toggleLightbox = (targetSlideIndex) => () => {
        const lightboxEl = document.querySelector('.gallery__lightbox')

        if (!!lightboxEl) {
            handleCloseLightbox()
            return
        }

        handleOpenLightbox(targetSlideIndex)
    }

    modal.addEventListener('click', (e) => {
        if (e.target !== e.currentTarget) return
        handleCloseLightbox()
    })

    lightboxSourceSlides.forEach((sourceSlide, index) => {
        sourceSlide.addEventListener('click', toggleLightbox(index))
    })
}

const gallerySliderContainerEls = document.querySelectorAll('.gallery')
gallerySliderContainerEls.forEach((sliderContainer) => {
    const gallerySwiperEl = sliderContainer.querySelector('.gallery__slider__swiper-el')

    const slides = gallerySwiperEl.querySelectorAll('.swiper-slide')
    createLightbox(slides)

    new Swiper(gallerySwiperEl, {
        modules: [Autoplay],
        slidesPerView: 1.2,
        autoplay: {
            delay: 5000
        },
        breakpoints: {
            [getBreakpointValue('md')]: {
                slidesPerView: 2.6
            },
            [getBreakpointValue('xxl')]: {
                slidesPerView: 3.5
            },
            [getBreakpointValue('xxxl')]: {
                slidesPerView: 4.5
            }
        }
    })
})

const imageSliderContainerEls = document.querySelectorAll('.image-slider')
imageSliderContainerEls.forEach((sliderContainer) => {
    const imageSwiperEl = sliderContainer.querySelector('.image-slider__swiper-el')

    const slides = imageSwiperEl.querySelectorAll('.swiper-slide')
    createLightbox(slides)

    new Swiper(imageSwiperEl, {
        modules: [Autoplay],
        slidesPerView: 1.2,
        autoplay: {
            delay: 5000
        },
        breakpoints: {
            [getBreakpointValue('md')]: {
                slidesPerView: 2.6
            },
            [getBreakpointValue('xxl')]: {
                slidesPerView: 3.5
            },
            [getBreakpointValue('xxxl')]: {
                slidesPerView: 4.5
            }
        }
    })
})
